import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { SharedUiLibraryModule } from '@cudirect/shared-ui-library';
import { WorkflowNavigationComponent } from './workflow-navigation/workflow-navigation.component';
import { WorkflowProgressComponent } from './workflow-progress/workflow-progress.component';

@NgModule({
  declarations: [WorkflowProgressComponent, WorkflowNavigationComponent],
  exports: [SharedUiLibraryModule, WorkflowNavigationComponent, WorkflowProgressComponent],
  imports: [CommonModule, RouterModule, SharedUiLibraryModule, SharedModule]
})
export class DynamicRenderSharedModule {}
